<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <form>
        <md-card>
          <md-card-header
              class="md-card-header-icon"
              :class="getClass(headerColor)"
          >
            <div class="card-icon">
              <md-icon>description</md-icon>
            </div>
            <h4 class="title">
              {{ $t(`muc.${oper}`) }}
              <small></small>
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-size-50">
              <div class="md-layout-item md-small-size-100 md-size-50">
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field
                      v-for="field in fields"
                      :key="field"
                  >
                    <label :for="field">
                      {{ $t(`muc.${field}`) }}
                    </label>
                    <template v-if="field==='work_maintenance_type'">
                      <md-select v-model="work.work_maintenance_type" :id="field" :name="field">
                        <md-option v-for="item in maintenance_types" :key="item.id" :value="item.id">
                          {{ $t(`mucs.${item.name}`) }}
                        </md-option>
                      </md-select>
                    </template>
                    <template v-else-if="field==='work_asset_type'">
                      <md-select v-model="work.work_asset_type" :id="field" :name="field">
                        <md-option v-for="item in asset_types" :key="item.id" :value="item.id">
                          {{ $t(`mucs.${item.name}`) }}
                        </md-option>
                      </md-select>
                    </template>
                    <template v-else-if="field==='work_unit'">
                      <md-select v-model="work.work_unit" :id="field" :name="field">
                        <md-option v-for="item in unit_types" :key="item" :value="item">
                          {{ item }}
                        </md-option>
                      </md-select>
                    </template>
                    <template v-else-if="field==='element'">
                      <md-select v-model="work.element" :id="field" :name="field">
                        <md-option v-for="item in elements" :key="item.code" :value="item.code">
                          {{ item.name }}
                        </md-option>
                      </md-select>
                    </template>
                    <template v-else-if="field==='work_name'">
                      <md-select v-model="work.work_name" :id="field" :name="field">
                        <md-option v-for="item in works" :key="item.name" :value="item.name">
                          {{ $t(`muc.work_${item.name}`) }}
                        </md-option>
                      </md-select>
                    </template>
                    <template v-else>
                      <md-input :id="field" :name="field"
                                v-model="work[field]"
                                :type="`${field}`"
                                :data-vv-name="`${field}`"
                                @input="onFieldChange(field)"
                      ></md-input>
                    </template>

                  </md-field>
                </div>
              </div>
              <div class="md-layout-item md-size-100 text-right">
                <md-button
                    class="md-success"
                    native-type="submit"
                    @click.native.prevent="validate"
                    :disabled="nothingSave"
                >
                  {{ $t('button.save') }}
                </md-button>
                <md-button class="md-accent" @click.stop.prevent="onCancel">
                  {{ $t('button.close') }}
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </form>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
//import {SlideYDownTransition} from 'vue2-transitions'
import Swal from 'sweetalert2'

export default {
  name: 'muc-work-profile-form',
  props: {
    headerColor: {
      type: String,
      default: ''
    },
    oper: String
  },
  components: {
    //SlideYDownTransition
  },
  async created() {
    this.$store.dispatch("LOAD_MAINTENANCE_TYPE_LIST").then((list) => {
      this.maintenance_types = [...list]
    })

    this.$store.dispatch("LOAD_ASSET_TYPE_LIST").then((list) => {
      this.asset_types = [...list]
    })

    this.$store.dispatch('LOAD_BRIDGE_WORK_LIST').then((list) => {
      this.works = [...list]
    })

    if (this.oper === "upd") {
      this.work = await this.$store.dispatch("GET_UNIT_COSTS_WORK_BY_ID", {muc_id: this.mid, work_id: this.work_id})
    }

    this.$store.dispatch("LOAD_BRIDGE_ELEMENT_LIST").then((list) => {
      this.elements = [...list]
    })
  },
  data() {
    return {
      work_id: this.$route.params.work_id,
      mid: this.$route.params.mid,
      nothingSave: true,
      work: {
        work_maintenance_type: undefined,
        work_asset_type: undefined,
        work_name: '',
        work_unit: '',
        work_fin_cost: 0,
        work_econom_cost: 0,
        element: '',
        element_name: '',
        comments: ''
      },
      maintenance_types: [],
      asset_types: [],
      elements: [],
      works: [],
      unit_types: ['m', 'm2', 'm3', 'pcs']
    }
  },
  methods: {
    onFieldChange() {
      this.nothingSave = false
    },
    onCancel() {
      this.$router.go(-1)
    },
    getClass: function () {
      //return 'md-card-header-' + headerColor + ''
    },
    async validate() {

      const alert = {
        type: 'success',
        text: '',
        footer: ''
      }

      const {
        work_maintenance_type,
        work_asset_type,
        work_name,
        work_unit,
        work_fin_cost,
        work_econom_cost,
        comments,
        element,
        element_name,
      } = this.work
      const data = {
        work_maintenance_type,
        work_asset_type,
        work_name,
        work_unit,
        work_fin_cost: +work_fin_cost,
        work_econom_cost: +work_econom_cost,
        comments,
        element,
        element_name
      }

      try {
        if (this.oper === "add") {
          await this.$store.dispatch('ADD_UNIT_COSTS_WORK', {muc_id: this.mid, data})
          alert.text= this.$t(`muc.record_was_added`)
        } else if (this.oper === "upd") {
          await this.$store.dispatch('UPD_UNIT_COSTS_WORK', {work_id: this.work_id, muc_id: this.mid, data})
          alert.text= this.$t(`muc.record_was_updated`)
        } else {
          throw "Unknown operation"
        }

        this.nothingSave = true
        Swal.fire(alert).then(() => {
          //this.touched.category = false
          this.$nextTick(() => this.$validator.reset())
        })
      } catch (err) {
        console.log(err)
        alert.type = 'error'
        if (this.oper === "add") {
          alert.text = this.$t(`muc.record_was_not_added`)
        }else if (this.oper === "upd") {
          alert.text = this.$t(`muc.record_was_not_updated`)
        }
        //alert.footer = this.$t(err)
        Swal.fire(alert)
      }
    }
  },
  watch: {},

  computed: {
    ...mapState({}),
    fields() {
      return ['work_maintenance_type', 'work_asset_type', 'work_name', 'element', 'element_name', 'work_unit', 'work_fin_cost', 'work_econom_cost', 'comments']
    }
  }
}
</script>
<style>
.md-button + .md-button {
  margin-left: 10px;
}
</style>
